import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Form = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  width: '100%',

  '& .MuiTextField-root': {
    '& .MuiOutlinedInput-root': {
      fontSize: '1rem',

      [theme.breakpoints.down('md')]: {
        fontSize: '0.95rem',
      },

      [theme.breakpoints.down('sm')]: {
        fontSize: '0.9rem',
      },

      [theme.breakpoints.down('xs')]: {
        fontSize: '0.85rem',
      },
    },

    '& .MuiInputLabel-root': {
      fontSize: '1rem',

      [theme.breakpoints.down('md')]: {
        fontSize: '0.95rem',
      },

      [theme.breakpoints.down('sm')]: {
        fontSize: '0.9rem',
      },

      [theme.breakpoints.down('xs')]: {
        fontSize: '0.85rem',
      },
    },

    '& .MuiFormHelperText-root': {
      fontSize: '0.875rem',

      [theme.breakpoints.down('sm')]: {
        fontSize: '0.8rem',
      },

      [theme.breakpoints.down('xs')]: {
        fontSize: '0.75rem',
      },
    },
  },

  [theme.breakpoints.down('lg')]: {
    gap: '18px',
  },

  [theme.breakpoints.down('md')]: {
    gap: '16px',
  },

  [theme.breakpoints.down('sm')]: {
    gap: '14px',
  },

  [theme.breakpoints.down('xs')]: {
    gap: '12px',
  },
}));

export const InputsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',

  [theme.breakpoints.down('lg')]: {
    gap: '18px',
  },

  [theme.breakpoints.down('md')]: {
    gap: '16px',
  },

  [theme.breakpoints.down('sm')]: {
    gap: '14px',
  },

  [theme.breakpoints.down('xs')]: {
    gap: '12px',
  },
}));
